import SectionPvzMap from "./SectionPvzMap";
import SectionZoneMap from "./SectionZoneMap";

export default class SectionDispatcher
{
    static get(profile)
    {
        if(!profile) {
            return false;
        }

        if(profile['CLASS_NAME'].indexOf("Pvz") >= 0) {
            return new SectionPvzMap();

        }

        if(profile['CLASS_NAME'].indexOf("Zone") >= 0) {
            return new SectionZoneMap();
        }

    }
}


